var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Modal_1;
import { defaultOptions } from '@slickdeals/durango/dist/javascript/decorators/defaultOptions';
import { showable, ClassNames as ShowableClassNames } from '@slickdeals/durango/dist/javascript/decorators/showable';
import { name as overlayName } from './overlay';
import Popup, { AnchorTypes, ClassNames as PopupClassNames, } from './popup';
import Button, { modifiers as ButtonModifiers } from './button';
import Icon from './icon';
import '../../scss/components/modal.scss';
/** The name of the module */
export const name = 'Modal';
/** Class names for Modals */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-modal";
    ClassNames["JavaScript"] = "js-modal";
    ClassNames["Content"] = "bp-c-modal_content";
    ClassNames["JavaScriptContent"] = "js-modal_content";
    ClassNames["CloseButton"] = "bp-c-modal_closeButton";
    ClassNames["FixedPosition"] = "bp-c-modal--fixed";
})(ClassNames || (ClassNames = {}));
let Modal = Modal_1 = class Modal extends Popup {
    /**
       * Create a Modal UI component
       *
       * @param options Data and options to initialize the component with
       */
    constructor(options) {
        // Override options passed in to always include an overlay and always anchor to the body
        super({
            ...options,
            overlay: true,
            anchorType: AnchorTypes.Body,
        });
    }
    /**
       * Performs any necessary initialization for the component
       */
    async init() {
        // Create the element on-the-fly
        // TODO: Allow modals to be loaded from HTML embedded on the page
        this.element = Modal_1.createElement({
            content: this.options.content,
            isFixed: this.options.isFixed,
        });
        if (this.options.closeButton) {
            const closeButton = Button.createElement('', [ButtonModifiers.unstyled]);
            closeButton.classList.add(ClassNames.CloseButton);
            closeButton.setAttribute('aria-label', 'Close Modal');
            closeButton.appendChild(Icon.createElement({ name: 'close' }));
            closeButton.addEventListener('click', this.hide.bind(this));
            this.element.prepend(closeButton);
        }
        super.init();
    }
    /**
       * Create a Modal HTML element
       *
       * @param options Options used for creating the element
       */
    static createElement(options) {
        // Create a Popup HTML element
        const element = Popup.createElement(options);
        // Add modal-specific classes to the container and content
        element.classList.add(ClassNames.Default, ClassNames.JavaScript);
        element.classList.add(ShowableClassNames.Default);
        if (options.isFixed) {
            element.classList.add(ClassNames.FixedPosition);
        }
        element.querySelector(`.${PopupClassNames.JavaScriptContent}`).classList.add(ClassNames.Content, ClassNames.JavaScriptContent);
        return element;
    }
};
Modal = Modal_1 = __decorate([
    showable(overlayName),
    defaultOptions({
        isFixed: false,
    })
], Modal);
export default Modal;
